import { render, staticRenderFns } from "./ProfileFavorited.vue?vue&type=template&id=9358f64e&"
import script from "./ProfileFavorited.vue?vue&type=script&lang=js&"
export * from "./ProfileFavorited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports